import { withViewModel } from '../../../../infrastructure/components/with-view-model';
import { HubAttendeeFormPresentation } from './hub-attendee-form-presentation';
import { HubAttendeeFormVM } from './hub-attendee-form.viewmodel';
import { IHubAttendeeDTO, IHubAttendeeListItemDTO } from '../../../../api/event-hubs.dao';

interface IHubAttendeeFormContainerProps {
    accountId: number;
    eventHubId: number;
    attendeeId?: number;
    initialAttendee?: IHubAttendeeListItemDTO;
    saveCompletedCallback: (attendee: IHubAttendeeDTO) => void;
    deleteHubAttendeeOnList?: () => void;
}

const HubAttendeeFormContainer = withViewModel(
    HubAttendeeFormPresentation,
    async (props: IHubAttendeeFormContainerProps) => {
        const hubAttendeeFormVM = new HubAttendeeFormVM(
            props.accountId,
            props.eventHubId,
            props.saveCompletedCallback,
            props.attendeeId,
            props.initialAttendee,
            props.deleteHubAttendeeOnList,
        );
        await hubAttendeeFormVM.initialize();
        return hubAttendeeFormVM;
    },
    () => []
);

export { HubAttendeeFormContainer as HubAttendeeForm };
